module.exports = __webpack_public_path__ + "static/media/MetaFest_bg.69864a69.jpg";